module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/photo7-1-6045eb90cac41d54fff8d624bf58176d.png";